import { cleanTrackingUrl } from './urlHelpers.js';

$(function () {
    window.homepageClickAnalytics = window.homepageClickAnalytics ||
        function (event, type, category, action, label, extraData) {
            if (event && event.button === 2) return;
            var url = event && event.currentTarget && event.currentTarget.href ? cleanTrackingUrl(event.currentTarget.href) : '';
            var fullLabel = url ? label + ' | ' + url : label;
            var pushData = {
                event: 'homepageClick',
                eventCategory: category,
                eventAction: action,
                eventLabel: fullLabel
            };
            if (extraData) {
                if (!extraData.tilePosition && event && event.currentTarget) {
                    var wrapper = event.currentTarget.closest('.contentFeedItemWrapper');
                    if (wrapper && wrapper.parentElement) {
                        extraData.tilePosition = Array.from(wrapper.parentElement.children).indexOf(wrapper) + 1;
                    }
                }
                Object.assign(pushData, extraData);
            }
            dataLayer.push(pushData);
            if (typeof ga === 'function') {
                // Legacy GA pipeline: send the plain label (no URL appended),
                // matching the navigation analytics behavior. The URL/fullLabel
                // lives only on the new dataLayer event above.
                ga('send', type, category, action, label);
            }
        };
});
